export default __webpack_public_path__ + "static/404-bg-67f76e0ddf87d5a6a339fdca2745e4dc.svg";